class OMRHeaderMenuMobile extends HTMLElement {
  constructor() {
    super();
    this.announcement = document.querySelector('.hdt-announcement-bar-section'); 
    this.topbar = this.querySelector('.hdt-top-bar');

    if(this.announcement){
      document.body.style.setProperty('--announcement-height', `${this.announcement.offsetHeight}px`);
    }
    if(this.topbar){
      document.body.style.setProperty('--topbar-height', `${this.topbar.offsetHeight}px`);
    }
  }
}
customElements.define('omr-header-menu-mobile', OMRHeaderMenuMobile);